import React, { FC } from 'react';

import TableProjectRoutes from "../../../components/table/projects/TableRoutesList";

interface ProjectRoutesProps {
    id: any;
}

const ProjectRoutes: FC<ProjectRoutesProps> = ({id}) => {
    return (
        <div>
            <TableProjectRoutes currentRoute={id}/>
        </div>
    );
};

export default ProjectRoutes;
